import React from 'react';
import { Heading } from '@devseed-ui/typography';
import {
  Inpage,
  InpageHeader,
  InpageHeaderInner,
  InpageBody,
  InpageBodyInner,
} from '../../styles/inpage';
import { StyledLink } from '../../styles/links';

export default class UhOh extends React.Component {
  render() {
    return (
      <Inpage>
        <InpageHeader>
          <InpageHeaderInner>
            <Heading size='xlarge'>Page Not Found</Heading>
          </InpageHeaderInner>
        </InpageHeader>
        <InpageBody>
          <InpageBodyInner>
            <p>Sorry, the page you are looking for is not available.</p>
            <br />
            <StyledLink to='/'>Return to Homepage</StyledLink>
          </InpageBodyInner>
        </InpageBody>
      </Inpage>
    );
  }
}
